import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const NoFilterStateContainer = styled.div<{ $dense?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(4)};

  height: 100%;
  width: 100%;
  gap: ${({ $dense }) => ($dense ? '0.8rem' : '1.6rem')};

  color: ${({ theme }) => theme.palette.grey[600]};
`;

export const IconContainer = styled.span<{ $dense?: boolean }>`
  font-size: ${({ $dense }) => ($dense ? '4.8rem' : '9.2rem')};
  line-height: 62.5%;
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.subtitle2)};
  color: ${({ theme }) => theme.palette.text.secondary};
  text-align: center;
`;
